import React from 'react'
import { compose, lifecycle, withHandlers, withState } from 'recompose'
import { /*FormattedMessage,*/ injectIntl } from 'react-intl'
import { bindActionCreators } from 'redux'

import md5 from 'blueimp-md5'

import { omit, pick, /*isEmpty, isNil*/ } from 'lodash'
import { connect } from 'react-redux'
import { uploadImage } from '../store/reducers/profile/uploadImage'
import { fetchingState } from '../helpers/hocs'
import { addPersonComment } from '../store/reducers/comments'
import { getIsLogged } from '../selectors/user'
import { getLoggedUser } from '../selectors/user'
//import { get as getPerson } from '../store/reducers/persons/info'
import { getPersonInfo } from '../store/reducers/personProfile'

import Button from '../components/Button'
import Input from '../components/Input'
import Close from '../components/Icons/Close'
import Loader from '../components/OverlayLoader'

// import { getComments, getCount, addComment } from '../../store/reducers/comments'



const PersonComments = ({ user, isLogged, submit, approve, status, onChange, personInfo, addPersonComment, commentText, fetching, images, lotId, upload, imagesState = {}, imageRemove, setImages, onSave, intl }) => (
    <div>
        {((status === 'completed') ? 
        (<div className='ProfileContainer__modal ProfileContainer__modal_red' style={{position: "relative"}}>
              <div className='ProfileContainer__modal-wrapper'>
                <div className='ProfileContainer__modal-header'>
                  <p className='ProfileContainer__modal-header-title'>
                    Спасибо!
                  </p>
                </div>
                <div className='ProfileContainer__modal-main'>
                  Мы передали ваши материалы на согласование!
                </div>
                
              </div>
              <div className='ProfileContainer__modal-close' onClick={approve}><Close fill="black"/></div>
            </div>)
            : 
    (<div className='ProfileContainer__modal' style={{ position: "relative" }}>
        <div className='ProfileContainer__modal-wrapper'>
            <div className='ProfileContainer__modal-header'>
                <p className='ProfileContainer__modal-header-title'>Вы можете оставить здесь все свои комментарии, менеджер проекта внесет их и вы получите материалы на согласование снова</p>
            </div>
            <div className='ProfileContainer__modal-main'>
                <Input
                    type='textarea'
                    value={commentText}
                    onChange={onChange.bind(this)}
                    placeholder={intl.formatMessage({ id: 'comments_index.write_comment' })}
                    isTextarea
                    //minRows={10}
                    minLength={500}
                    maxLength={1200}
                    length={commentText ? commentText.length : 0}
                />
                <div className='ProfileContainer__photos'>
                    <div className='modal__photos-preview'>
                        <div className='person-tmpPhotos'>
                       
							<div className='person-tmpPhotos'>
								<div className='person-tmpPhotos-title person-tmpPhotos-title_profile'>Прикрепить фото</div>
								<div className='person-tmpPhotos-items'>
									<div className='person-tmpPhoto-item'>
										<input className='modal__photos-field' type='file' multiple onChange={upload} style={{ display: "none" }} id='person-photos' />
										<label htmlFor="person-photos">
											<div className='person-tmpPhoto-addBlock' />
										</label>
									</div>
								</div>
							</div>
						

						<div className='item _person-image'>
							<div className='modal__photos'>
								{/* <label className='AddPhoto' style={{marginBottom: Object.keys(imagesState).length > 0 ? '20px' : 0}}>
								Прикрепить фото
								<input className='modal__photos-field' type='file' multiple onChange={upload} />
							</label> */}
								<div className='modal__photos-preview'>
									{Object.keys(imagesState).map(key => (
										<div className='modal__photos-preview-item' key={key}>
											{(imagesState[key] < 100 || !images || !images[key])
												?
												<Loader isLight />
												:
												(<div className='modal__photos-preview-img'>
													<img src={images[key].url} alt={images[key].name} className='person-photo' />
													<span className='modal__photos-preview-overlay Text' onClick={imageRemove.bind(this, key)}>
														<span className='modal__photos-preview-overlay__after'>
															{intl.formatMessage({ id: 'profile_report.delete_photo' })}
														</span>
													</span>
												</div>)
											}
										</div>
									))}
								</div>
							</div>
						</div>
                            <p className='ProfileContainer__modal-description'>фото должно быть анфас/портрет, размер от 800 кб</p>
                        </div>
                    </div>
                </div>
            </div>
            <Button onClick={submit}>Отправить</Button>
        </div>
        <div className='ProfileContainer__modal-close' onClick={onSave}><Close fill="black" /></div>

    </div>
        ))}
    </div>
)



const mapStateToProps = state => ({ isLogged: getIsLogged(state), user: getLoggedUser(state), ...state.images, ...state.profile.report})

const mapDispatchToProps = dispatch => bindActionCreators({ addPersonComment, uploadImage, getPersonInfo }, dispatch)

// const mergeProps = (state, dispatch, props) => ({
//     ...props,
//     ...state,
//     // getComments: (offset = 0) => {
//     //     if (!props.type || !props.entryId) return
//     //     return props.fetchingWrap(dispatch.getComments.bind(this, props.entryId, props.type, { offset, limit: offset ? 10 : 5 }, !offset), 'list')
//     // },
//     // getCount: () => {
//     //     if (!props.type || !props.entryId) return
//     //     return dispatch.getCount(props.entryId, props.type)
//     // },
//     addPersonComment: (message, images) => {
//         props.onSave();
//         if (!props.entryId) return
//         return props.fetchingWrap(dispatch.addPersonComment.bind(this, props.entryId, message, images), 'add')
//     }
// })

export default injectIntl(compose(
    fetchingState({ multi: true }),
    //fetchingState(),
    connect(mapStateToProps, mapDispatchToProps),
    withState('commentText', 'setCommentText', ''),
    withState('commentErr', 'setCommentErr', null),
    withState('imagesState', 'setImages', {}),
    fetchingState(),
    withHandlers({
        onChange: ({ setCommentText }) => e => {
            let value = e.target.value.replace(/(<([^>]+)>)/ig, '')
            setCommentText(value)
        },
        approve:({ addPersonComment, fetching, lotId, status, onSave, images }) => async e => {
            e.preventDefault()

            let entryId = lotId;
            let message = "Лот подтверждён";
            console.log(entryId, status, message);

            await addPersonComment(entryId, message, images, status)
            onSave();
        },

        submit: ({ addPersonComment, getPersonInfo, status, setImages, fetching, setCommentErr, setCommentText, commentText, images, imagesState, lotId, onSave }) => async e => {
            if (e.key && e.key !== 'Enter') return
            else if (fetching.add) return
            else e.preventDefault()

            let error = null
            if (!commentText || !commentText.length) error = 'no_comment_text'
            setCommentErr(error)
            if (error) return
            
            if (Object.values(images).length > 0) {
				images = Object.values(pick(images, Object.keys(imagesState))).map(el => el._id)
            }
			
            let entryId = lotId;
            let message = commentText;

            let result = await addPersonComment(entryId, message, images, status)
            if (result === 200) 
            {
                onSave();
                setCommentText('');
                setImages({});
                await getPersonInfo()
            }
        },

        upload: ({ setImages, uploadImage, imagesState, images }) => (e) => {
            const files = e.target.files
            console.log(imagesState);

            try {
                for (let i = 0; i < files.length; i++) { // images
                    const file = files.item(i)

                    imagesState[md5(file.name)] = 0
                    setImages(imagesState)

                    const onUpload = (e) => {
                        imagesState[md5(file.name)] = Math.floor((e.loaded * 100) / e.total)
                        setImages(imagesState)
                    }
                    uploadImage(file, onUpload)
                }
            } catch (e) {
                alert(e)
            }

        },
        imageRemove: ({ setImages, imagesState }) => (key, e) => {
            e && e.preventDefault()
            setImages(omit(imagesState, key))
        },
    }),
    lifecycle({
        componentWillMount() {
            this.props.getPersonInfo()
        },
        componentWillUnmount() {
            this.props.setImages({})
        },
        componentWillReceiveProps(np) {
            console.log('пропсы на форме*******************', np)
        },	
        componentDidUpdate() {
			
		},
    })
)(PersonComments))



// WEBPACK FOOTER //
// ./src/containers/PersonComments.jsx